type Props = {
  title: string;
  subtitle?: React.ReactNode;
  onSubmit?: React.FormEventHandler;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

export default function FormShell({ title, subtitle, children, onSubmit, footer }: Props) {
  return (
    <div className="flex w-full items-center justify-evenly px-4">
      <div className="flex flex-col items-center justify-evenly w-full max-w-md gap-12">
        {/* Header */}
        <div className="flex flex-col gap-2 text-center">
          <h1 className="text-2xl font-bold">{title}</h1>
          {subtitle && (
            <div className="text-sm text-balance text-muted-foreground">{subtitle}</div>
          )}
        </div>

        {/* Form */}
        <form onSubmit={onSubmit} className="flex flex-col gap-6 w-full">
          {children}
        </form>

        {/* Footer */}
        {footer && <div>{footer}</div>}
      </div>
    </div>
  );
}
